import {simpleRequest} from "../apiConfigs/request";

export const fetchCandidateScreeningProfile = (screeningUuid) => {
    return simpleRequest({
      url: `/screening/candidate/${screeningUuid}`,
      method: 'GET'
    });
  }

export const saveCandidateScreeningProfile = (screeningUuid, data) => {
  return simpleRequest({
    url: `/screening/candidate/${screeningUuid}`,
    method: 'PATCH',
    data,
  });
}

export const getCandidateRegistrationFields = () => {
  return simpleRequest({
    url: `/screening/candidate-registration-fields`,
    method: 'GET',
  });
}

export const fetchJobTemplates = () => {
  return simpleRequest({
    url: `/public/job-templates`,
    method: 'GET',
  });
}

export const registerCandidateScreeningProfile = (data) => {
  return simpleRequest({
    url: `/screening/candidate-registration`,
    method: 'POST',
    data,
  });
}